module.exports = __webpack_public_path__ + "static/media/home-wood-2.869894be.jpg";